import { apiCall } from "@/common/api/ApiResult.model";
import axios from "axios";
import { AppScript, BaseAppScript, TemplateVarsMap } from "./models";

export const get_template_vars_map = apiCall<void, TemplateVarsMap>(
  "it-scripts.vars-map",
  async () => {
    const res = await axios.get("/script/all/variants");
    return {
      success: true,
      value: res.data.variants,
    };
  }
);

export const get_all_scripts = apiCall<void, BaseAppScript[]>(
  "it-scripts.scripts",
  async () => {
    const res = await axios.get("/script/all/brief");
    return {
      success: true,
      value: res.data.scripts,
    };
  }
);

export const get_full_script = apiCall<string, AppScript>(
  "it-scripts.full-script",
  async (script_id) => {
    const res = await axios.get(`/script/${script_id}`);
    return {
      success: true,
      value: res.data.script,
    };
  }
);

export const create_get_entities_job = apiCall<
  Record<string, string>,
  { job_ids: string[] }
>("it-scripts.get-entities", async (variants) => {
  const res = await axios.post("/script/job", { variants });
  return {
    success: true,
    value: res.data,
  };
});

export const check_get_entities_job_status = apiCall<
  string,
  { status: string } // "new|in-progress|done"
>("it-scripts.get-entities-job-status", async (job_id) => {
  const res = await axios.get(`/script/job/status/${job_id}`);
  return {
    success: true,
    value: res.data,
  };
});
